import { useState, useEffect } from "react";

/**
 * ブラウザのタイムゾーンを取得するカスタムフック
 * SSR時はUTCをフォールバックとして使用
 * @returns ブラウザのタイムゾーン文字列（例: "Asia/Tokyo", "America/New_York"）
 */
function useBrowserTimeZone(): string {
  const [browserTimeZone, setBrowserTimeZone] = useState("UTC");
  
  useEffect(() => {
    if (typeof window !== "undefined") {
      setBrowserTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }
  }, []);

  return browserTimeZone;
}

export default useBrowserTimeZone;

